<script>
	import ReadOnlyPersonalDetails from "../../components/readonly/ReadOnlyPersonalDetails.svelte";
	import WorkDetails from "./WorkDetails.svelte";

	import { pageNumber, model } from "../../stores";
	console.log($model);

	export let pageIndex = null;
	export let pageTitle = null;

	let disabled = true;

	pageNumber.update((p) => pageIndex);
	document.title = pageTitle;
</script>

<section>
	<h1>McDonald's Class Action Registration</h1>

	<ReadOnlyPersonalDetails></ReadOnlyPersonalDetails>
	<WorkDetails {disabled}></WorkDetails>
</section>
